const appConfig = {
    apiPrefix: '/',
    authenticatedEntryPath: '/visits',
    firstLoginPath: '/home-login',
    selectProject: '/select-project',
    pollsDashboard: '/pollsDashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '',
    enableMock: false,
    AuthCheckTime: 1*process.env.REACT_APP_AUTH_CHECK_TIME,
    CacheTime: 1*process.env.REACT_APP_CACHE_TIME,
    APIURL: process.env.REACT_APP_API_URL,
    BASEURL: process.env.REACT_APP_BASE_URL,
    // Yalnız test'te açık (.env REACT_APP_TEST_FEATURES=true): Fraud Kontrol ve İtiraz Listesi menüleri,
    // drawer'daki "Düzenleme Talep Et"in setobjection'a gitmesi. Canlıda kapalı: menüler gizli, talep nosimia "itirazlar"a gider
    TestFeatures: process.env.REACT_APP_TEST_FEATURES === 'true',
    APIUsername: process.env.REACT_APP_API_USERNAME,
    APIPassword: process.env.REACT_APP_API_PASSWORD,
    isCached: timeStamp => {
        return appConfig.CacheTime + timeStamp < Date.now()
    }
}

export default appConfig